import { Progress } from "@/components/ui/progress";

export default function DonationProgress({ needed = 0, received = 0, donorCount, testId }) {
  const pct = needed > 0 ? Math.min(Math.round((received / needed) * 100), 100) : 0;
  const remaining = Math.max(needed - received, 0);
  return (
    <div data-testid={testId || "donation-progress"} className="w-full">
      <div className="flex items-center justify-between mb-1.5 text-sm">
        <span className="font-semibold text-amtm-text">
          ₹{received.toLocaleString("en-IN")} raised
          {donorCount > 0 && <span className="text-amtm-textMuted font-normal"> &middot; {donorCount} donor{donorCount === 1 ? "" : "s"}</span>}
        </span>
        <span className="text-amtm-textMuted">of ₹{needed.toLocaleString("en-IN")}</span>
      </div>
      <Progress value={pct} className="h-2.5 bg-amtm-teal/15" />
      {remaining > 0 && (
        <p className="text-xs text-amtm-textMuted mt-1.5" data-testid={testId ? `${testId}-remaining` : "donation-progress-remaining"}>
          ₹{remaining.toLocaleString("en-IN")} to go
        </p>
      )}
    </div>
  );
}
